import {
     GET_SYSTEM_ADMIN_CERTIFICATE,
     UPDATE_SYSTEM_ADMIN_CERTIFICATE,
     ADD_SYSTEM_ADMIN_CERTIFICATE,
     ADD_SYSTEM_ADMIN_CERTIFICATES,
     DELETE_SYSTEM_ADMIN_CERTIFICATE,
} from './types';

const initialState = [];

const certificateReducer = (state = initialState, { type, payload }) => {
     switch (type) {
          case GET_SYSTEM_ADMIN_CERTIFICATE:
               return state.find((certificate) => certificate.id === payload);

          case UPDATE_SYSTEM_ADMIN_CERTIFICATE:
               return state.map((certificate) => {
                    if (certificate.id === payload.id) {
                         certificate = payload;
                    }
                    return certificate;
               });

          case ADD_SYSTEM_ADMIN_CERTIFICATE:
               return [...state, payload];

          case ADD_SYSTEM_ADMIN_CERTIFICATES:
               return payload;

          case DELETE_SYSTEM_ADMIN_CERTIFICATE:
               return [...state.filter((certificate) => certificate.id !== payload)];

          default:
               return state;
     }
};

// Fetch Certificate by id
export const getCertificateById = (state, certificateId) => {
     const certificates = [...state.admin.certificates];
     const certificate = certificates.find((certificate) => certificate.id === certificateId);
     return certificate || {};
};

export default certificateReducer;
